/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { apiKeyRoute } from "../components/APIKeys/route";
import {
  contactRoute,
  faqRoute,
  tutorialsRoute,
} from "../components/Help/route";
import { invoicesRoute } from "../components/Invoices/route";
import { planRoute } from "../components/Plan/route";
import { CardEdit } from "../components/Profile/CardEdit";
import { profileRoute } from "../components/Profile/route";
import { Typography } from "@material-ui/core";
import React, { Suspense } from "react";
import { Resource } from "react-admin";

const UsageList = React.lazy(
  async () => await import("../components/Usage/UsageList")
);
const UsageListWithSuspense = (props) => {
  return (
    <Suspense fallback={<Typography variant="body1">Loading...</Typography>}>
      <UsageList {...props} />
    </Suspense>
  );
};
// custom routes are for pages that don't match a resource endpoint
export const customRoutes = [
  apiKeyRoute, // need custom route because the show component is not working maybe?
  profileRoute,
  planRoute,
  faqRoute,
  tutorialsRoute,
  invoicesRoute,
  contactRoute,
];

// one resource for each endpoint
// if endpoint matches default page, then supply component
export const resources = [
  <Resource key="api-keys" name="api-keys" />,
  <Resource key="billing/address" name="billing/address" />,
  <Resource
    key="billing/credit-card"
    name="billing/credit-card"
    edit={CardEdit}
  />, // used by account info
  <Resource key="billing/invoices" name="billing/invoices" />,
  <Resource key="subscriptions" name="subscriptions" />,
  <Resource key="users" name="users" />,
  <Resource key="users/profile" name="users/profile" />,
  <Resource key="usage" name="usage" list={UsageListWithSuspense} />, // no custom route, needs component
];
